export default __webpack_public_path__ + "static/media/background_image.9e35e680.png";